module.exports = {
	"a1": {
		"title": "Communicating with Potentially Violent/Aggressive Clients",
		"sections": [
			{
				"subTitle": "Verbal Communication",
				"tips": [
					"Make your first contact neutral or non-directive: for example, ask how you can help. This inquiry communicates a sense of normal interaction.",
					"Focus your attention on the other person to let them know you are interested in what they have to say.",
					"Maintain a calm and reassuring demeanor. Try to calm the other person – DO NOT allow the other person’s anger to become your anger.",
					"Always be courteous to clients despite their behaviour. Introduce yourself and call them by name.",
					"Remain conscious of how you are delivering your words, and how receptive your body language and posture is.",
					"Use empathy – acknowledge the client’s feelings – confirm that you know they are upset.",
					"Use active listening skills. Do not interrupt.",
					"Confirm your understanding of the issue or problem by repeating what the client has told you.",
					"Acknowledge the client’s feelings and concerns.",
					"Use simple language; avoid jargon or technical language.",
					"Speak slowly, quietly and confidently.",
					"Remain open-minded, objective, and non-judgmental.",
					"Encourage the person to talk and express themselves as this will assist in decreasing their tension. DO NOT tell the person to relax, chill or calm down.",
					"Always be honest. Do not make promises that you cannot keep.",
					"Keep the client’s attention focused on the current issue.",
					"Use silence as a calming tool.",
					"Always attempt to explain delays or long waiting periods. Not doing so can be construed as discourtesy.",
					"Be prepared to apologize as necessary and accept criticism positively.",
					"Avoid giving commands.",
					"Look for ways to the help the person save face.",
					"In a calm and non-threatening way, explain that violence is unacceptable and is not tolerated.",
					"If you feel threatened, politely and calmly terminate the interaction."
				]
			},
			{
				"subTitle": "Body Language",
				"tips": [
					"Stand about one metre (three feet) away (generally, this distance is outside the individual’s personal space), on an angle (as opposed to directly in front of the person) and on the person’s non-dominant side (people usually wear watches and part hair on the non-dominant side). Place yourself so that you have a clear exit.",
					"Avoid pointing or gesturing; make no sudden movements, avoid touching the person, avoid staring eye contact.",
					"Use calm body language: hands open, attentive facial expression, relaxed posture.",
					"Position yourself on the same physical level; avoid standing over the person."
				]
			}
		]
	},
	"a2": {
		"title": "Terminating an Interaction with an Angry Client",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Call the police.",
					"Calmly but politely interrupt the conversation.",
					"Document the incident.",
					"Either leave or ask the person to leave.",
					"If the person does not leave, inform a manager or supervisor immediately.",
					"If you threaten to call the police, be prepared to call them.",
					"Tell the person that the conversation is over.",
					"Use personal safety response systems such as personal alarms and mobile phones."
				]
			}
		]
	},
	"a3": {
		"title": "Guidelines for Non-verbal Behaviour and Communication",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Use calm body language – relaxed posture with hands unclenched, above waist and visible.",
					"Have an attentive expression on your face.",
					"Arrange yourself so your exit is not blocked.",
					"Position yourself at an angle rather than directly in front of the other person (Supportive Stance – protects vital organs and less confrontational, easier to get away).",
					"Give the person enough physical space. This varies by culture and other factors but normally two to four feet is considered adequate space.",
					"Document the incident.",
					"Activate personal safety response system as necessary. Inform the supervisor and either the supervisor or employee should call the police and report the incident. Threats of violence are illegal under the Criminal Code section 264.1 – Uttering Threats. The police will provide you with a case number and speak to the offender."
				]
			}
		]
	},
	"a4": {
		"title": "Guidelines for Telephone Threats",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"If client is abusive, explain that their language is not acceptable and that you will terminate the call unless they refrain from such behaviour.",
					"Be firm and consistent.",
					"Hang up if necessary.",
					"Try to avoid taking the situation personally.",
					"If you receive a threatening phone call and know the person, let them know their behaviour is not acceptable and end the call.",
					"If you receive a threatening phone call and don’t know the person, take notes on everything said and observations about background noise, voice characteristics, etc."
				]
			}
		]
	},
	"b1": {
		"title": "Planning Travel",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Get to know the area, particularly the safe area in the district.",
					"Plan the route and method of travel well in advance. Have insurance if travelling by car.",
					"Keep pertinent telephone numbers (destination, taxi service, hotel, rental car agency, reliable tow truck company, etc.) handy.",
					"Wear comfortable, conservative clothing and shoes with non-skid soles. Do not wear expensive jewelry or show large amounts of money. Religious symbols should be worn discreetly. Avoid earrings or accessories that could be grasped or pulled by another person.",
					"Avoid driving in isolated or dangerous areas. Plan the safest route to and from the client’s home, even if it isn’t the most direct. If travelling through dangerous areas is unavoidable, travel with a companion and note nearby police stations, public telephones and other public buildings such as hospitals and restaurants or stores that remain open late. If possible, arrive during daylight hours.",
					"Carry a cell phone, personal alarm and consider safety features in vehicles such as automatic locks and alarms. Do not wear headphones, for example, as they will limit your ability to heat sounds around you. Always be aware of your surroundings.",
					"Keep money in an accessible pocket to eliminate searching through a purse or wallet.",
					"Advise your office when you arrive."
				]
			}
		]
	},
	"b2": {
		"title": "Travelling by Public Transit",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Walk confidently with head erect.",
					"Keep an up-to-date transit schedule in an easy-to-access location.",
					"Have the exact change ready in a pocket. Avoid opening your purse or wallet.",
					"If possible, travel during the day.",
					"Always wait at a designated transit stop. Stand with a group of people rather than alone.",
					"Avoid isolated or poorly lit bus stops.",
					"Plan to arrive time at the transit stop just before your bus/streetcar does.",
					"On the bus or streetcar, try to sit where you can see your upcoming stop as you approach. If you see suspicious or menacing individuals at your stop, get off at the next stop.",
					"When stepping off the bus, check to see if you are being followed. If you are, walk directly and quickly – without running or looking back – to a service station or store. Call 911.",
					"If possible, plan to have someone meet you at your home bus stop.",
					"Stand away from the edge of the subway platform and use the alarms in the subway, bus, streetcar as necessary.",
					"Stand or sit near the driver or streetcar operator or in the Designated Waiting Area of the subway platform.",
					"If someone is bothering you, or if you feel threatened, let the driver know immediately.",
					"Move instantly if jostled – it helps to foil pickpockets.",
					"Always be aware of your surroundings.",
					"Avoid direct eye contact with other travelers and do not participate in lengthy conversations with people in the street.",
					"If taking a taxi, check that the driver’s identification and photo are clearly displayed and match the driver.",
					"Sit behind the front passenger seat.",
					"State the route you prefer, sticking to the main streets. State that someone is waiting for you.",
					"If you become uneasy with the driver, request that he or she pull over and let you out."
				]
			}
		]
	},
	"b3": {
		"title": "Walking in the Community",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Walking with your head erect, appearing alert and, scanning your route, proceed directly and quickly to the client’s home.",
					"Use the main entrance as much as possible – avoid rear or secluded entrances."
				]
			}
		]
	},
	"c1": {
		"title": "Travelling by Car",
		"description": "Staff should be responsible for ensuring that their cars are road-ready by servicing them regularly (e.g. every six months). They are also responsible for employing safe driving practices, such as getting snow tires in winter or using four-wheel drive in the north.",
		"sections": [
			{
				"subTitle": "Vehicle Checklist",
				"tips": [
					"Use steel-belted radial tires to reduce the chance of a flat tire and keep the tires properly inflated.",
					"Check windshield wiper fluid level, battery and lights.",
					"Keep the gas tank more than half full at all times."
				]
			},
			{
				"subTitle": "Winter Survival Kit - In the trunk",
				"tips": [
					"Axe or hatchet",
					"Booster cables",
					"Cloth or paper towels",
					"Compass",
					"Emergency food pack",
					"Extra clothing/footwear",
					"Fire extinguisher",
					"Ice scraper and brush",
					"Matches, survival candle in a deep can",
					"Methyl hydrate (for fuel line and windshield de-icing)",
					"Road maps",
					"Sand, salt or kitty litter",
					"Shovel",
					"Tow chain",
					"Traction mats or 'ladder'",
					"Warning light or road flares",
					"Safety vest",
					"Work gloves"
				]
			},
			{
				"subTitle": "Winter Survival Kit - In the car",
				"tips": [
					"Flashlight",
					"First-aid kit",
					"Survival blanket",
					"'Call Police' sign: durable, reflective plastic sign that hooks on the window and is visible from both directions at any time during any weather"
				]
			}
		]
	},
	"c2": {
		"title": "Safe Driving Practices",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Always approach your car with your car keys already in hand. Hold one key between your thumb and first finger so that the key can be used to as a weapon to protect yourself. Having your keys in your hand also allows you to quickly enter your car.",
					"In above-ground parking lots, park in well-lit areas near the main entrance or exit to the building.",
					"In underground parking lots, back into the parking space so you can leave the parking lot area quickly and safely.",
					"Check underneath the vehicle as you approach to make sure no one is hiding there, then check the back seat before getting into your car. If you notice someone near, at or in your vehicle, go to a safe area and contact security or the police.",
					"Keep the car doors locked and the windows closed when parking.",
					"Keep the doors locked when travelling in your car.",
					"Always use seat belts.",
					"Refrain from using the cell phone while driving. Pull off the road to make a call and limit phone use to emergencies.",
					"Consider using a head set or speaker phone in the car.",
					"Refrain from smoking in the car. Cigarette smoke leaves a film on windows and nicotine and carbon monoxide can reduce night vision.",
					"Do not wear sunglasses at night: they do not reduce headlight glare.",
					"Switch from high beams to low during night driving when within 150 m (500 feet) of an oncoming vehicle, or approaching within 60 m (200 feet) of turns and the crest of hills on country roads.",
					"Develop a routine for looking ahead, from side to side and in the rear view mirror.",
					"Check mirrors every five to 10 seconds and always before stopping or changing lanes.",
					"Always check blind spots by turning your head when changing lanes.",
					"Move away from drivers who are moving erratically.",
					"In traffic queues, stop when you can still see the wheels of the car ahead. At that distance, you can always get your car out of the queue and you have a buffer if hit from behind.",
					"Keep your foot firmly on the brake when you are stopped.",
					"If you suspect that you are being followed, note the car’s license number and go immediately to a police, fire or service station. Do not leave the car, but honk your horn repeatedly until someone responds. Do not go home.",
					"If you are driving to a client’s home, avoid parking directly in front of the home. Park next door so that you can see the front and sides of the dwelling as you approach.",
					"Roll up the windows and lock the car.",
					"Do not leave personal or nursing items visible.",
					"Leave purses at home and carry identification and money in front pockets.",
					"Post a sign on the dashboard stating that no drugs or equipment are inside the car.",
					"Park in open areas.",
					"Avoid underground parking garages. But, if you must use one, park near an exit in a well-lit area.",
					"Back into the parking spot and take a few minutes to observe the surroundings.",
					"Avoid parking beside a van or other large vehicle where you could be wedged in.",
					"If your car breaks down, try to get it to the side of the road. Put on the emergency flashers. Do not get out of the car. Keep the doors locked and the windows closed. Use your cell phone to call for assistance. If you do not have a cell phone, place a “Call Police” sign on the windshield.",
					"If someone other than a police officer comes to the car to assist you, open the window no more than 2 cm (1 inch) to speak to them.",
					"Do not accept help from a stranger. Ask the person to call the police or a towing service."
				]
			}
		]
	},
	"c3": {
		"title": "What to Do if Confronted by an Aggressive Driver",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Avoid eye contact and refrain from exchanging words or gestures and from retaliatory driving manoeuvres.",
					"Stay in control. Allow the driver to pass. Drop back and let them get far ahead.",
					"If pursued, go directly to a nearby safe area or police station.",
					"Use a cell phone to call for help."
				]
			}
		]
	},
	"c4": {
		"title": "Parking Your Vehicle",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"If possible, park on the premises rather than on the street.",
					"Walk confidently with head up and be aware of your surroundings.",
					"Park as close to the home/building as possible, especially during the evening or night.",
					"Know where emergency telephones are.",
					"Look around before leaving your vehicle.",
					"Avoid leaving valuables inside your vehicle.",
					"Avoid locking your purse in the trunk of your vehicle while on site (lock it in the trunk before you arrive).",
					"Use the main entrance; avoid rear or secluded entrances.",
					"Put your keys in your hand before leaving the home/building and carry a whistle or another type of personal alarm.",
					"If you notice someone loitering near your vehicle, do not go to your vehicle; go to a safe area and contact the police.",
					"When approaching your vehicle, check underneath from a distance to ensure no one is hiding there or behind the vehicle.",
					"Look inside your vehicle before getting in.",
					"Once inside your vehicle, lock all doors and keep all windows up."
				]
			}
		]
	},
	"c5": {
		"title": "Returning to Your Vehicle",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Prepare yourself to leave the client’s home with everything you need, such as the key to open your vehicle, and a whistle or other personal alarm.",
					"Use the main entrance as much as possible — avoid rear or secluded exits.",
					"Scan the area for suspicious or menacing individuals. Have a back-up plan if there is danger.",
					"Walk with your head erect, appear alert and, scan your route, and proceed directly and quickly to your vehicle.",
					"Once you are in your vehicle, ensure all doors are locked and windows are up."
				]
			}
		]
	},
	"d1": {
		"title": "Personal Attack Tips",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Make a scene, yell or scream as loud as possible – shout words like STOP! HELP! FIRE! Run to a nearby store or the nearest well-lit area and continue calling for help.",
					"If you are being pulled or dragged along, fall to the ground and roll.",
					"Blow a whistle, activate a personal alarm or activate a fire alarm or any other device that would create a scene (Refer to PSHSA’s PSRS Toolkit as needed)",
					"If you are in a public area, give bystanders specific instructions to help you. Single someone out and send them for help, e.g. 'You in the yellow shirt, call the police!'",
					"If someone grabs your purse, briefcase or other belongings, DO NOT resist. Throw the item to the ground several feet away from the thief and run in the opposite direction yelling 'HELP! DO NOT chase the thief.''",
					"Call the police immediately after any incident (when it is safe to do so) and report the appearance and mannerisms of the offender."
				]
			}
		]
	},
	"d2": {
		"title": "Tips for When a Weapon is Involved",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Never try to disarm an armed Individual. If possible, try to leave the location and call 911.",
					"Never accept a weapon from an upset, agitated individual; the person may change their mind and turn the weapon on you. Ask them to set it down on the floor or counter.",
					"Use personal safety response systems – e.g. personal alarms and mobile phones",
					"If you are assaulted, call 911 as soon as it is safe to do so.",
					"Report the incident to your supervisor as soon as possible",
					"Write down your recollection of the incident as soon as possible to assist the police or hospital staff with details",
					"After a traumatic incident, seek support and/or counselling (through the internal debriefing process or the employee and family assistance program)"
				]
			}
		]
	},
	"e1": {
		"title": "Point-of-care Staff Work Practice Assessment",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Are the client’s wishes and needs considered when establishing a client care plan?",
					"Does the client history include the likelihood of a client exhibiting violent, aggressive or responsive behaviour? (refer to PSHSA’s ICRA & Flagging Toolkit, as needed)",
					"Is there is a process to communicate the risk of violence e.g. flagging client charts who are assessed at-risk for violent, aggressive or responsive behaviour? Are such factors as personality, medications, type or degree of illness and history considered?",
					"Is client confidentiality balanced with employee safety?",
					"Does the organization support a flexible care plan designed to meet the needs of your clients?",
					"Are there certain client care activities that must be performed at a specific time of day?",
					"Is a standard assessment conducted on clients to determine the likelihood and triggers of violent, aggressive, or responsive behaviour?",
					"Is staff safety considered when designing a client care plan?",
					"Do you explain to a client what you are going to do and how you are going to do it each time you engage in a client care activity?",
					"Is the client kept informed about treatment, procedures and care planning?",
					"Are the client’s privacy and dignity respected during care activities?",
					"When client assignments are being completed by one person working in isolation, can the job be done more safely with two people working together?",
					"Are clients’ scheduled appointments kept promptly?",
					"Are staff educated in recognizing escalating behaviour and patterns of violence?",
					"Are staff educated in effective communication techniques?",
					"Do staff know how to respond when confronted by a violent or aggressive client or family member(s)?",
					"Do staff know how to access help quickly?",
					"Is there is an effective emergency response mechanism that staff can readily access to summon immediate help in an emergency situation (i.e., use of cell phone; immediate exit)?",
					"Can staff review a client’s profile before meeting with that client?",
					"Are regular case management meetings held with all staff who are directly or indirectly involved in the care of potentially violent clients?",
					"Are ways to deal with violent or aggressive clients discussed and client care plans updated to indicate factors that trigger violence and suggest controls?",
					"Are staff who are more experienced or staff who have a demonstrated ability to handle potentially violent situations assigned to high-risk areas or to high-risk clients?",
					"Before approaching a client, do you make sure that the lighting is adequate?",
					"Are a comfortable temperature and low noise levels are maintained?",
					"If clients resist or become hostile during care, is the care stopped immediately?",
					"If you feel threatened in any way during client care, is there a process to request the presence of another staff member?"
				]
			}
		]
	},
	"e2": {
		"title": "Client Aggression Risk Factors",
		"sections": [
			{
				"subTitle": "",
				"tips": [
					"Language or cultural barriers",
					"Diagnosis (psychogeriatric illness, mental illness, medical condition)",
					"Poverty",
					"Fear",
					"Loss of control",
					"Loneliness",
					"Frustration",
					"Boredom",
					"Effects of medications or lack of medication",
					"Anniversary of a significant event",
					"Losses (friends, family, no support system)",
					"Lack of information",
					"Time of day or week (“sundown syndrome”)",
					"Task too complicated",
					"Physiological needs (fatigue, hunger, need to void)",
					"Reaction to race and sex of caregiver"
				]
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/common/appendix.json
// module id = 435
// module chunks = 0